if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.emptyCart = document.querySelector('cart-drawer').classList.contains('is-empty');

				this.form = this.querySelector('form');
				this.form.querySelector('[name=id]').disabled = false;
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');

				if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('[type="submit"]').classList.add('loading');

				this.querySelector('.loading__spinner').classList.remove('hidden');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButton.querySelector('span').classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response,
							});
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');
						this.querySelector('[type="submit"]').classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton.removeAttribute('aria-disabled');
						this.querySelector('.loading__spinner').classList.add('hidden');

						if (document.querySelector('tpt-quantity-input')) {
							document.querySelector('.sticky-add-cart').classList.remove('loading');
							document.querySelector('tpt-quantity-input .quantity__input').value = 1;
						}

						if (document.querySelector('tpt-trigger-add-cart')) {
							document.querySelector('tpt-trigger-add-cart').classList.remove('loading');
						}

						/**
						 * Upsell product cart
						 */

						if (document.querySelector('.cart-upsell-container') && document.querySelector('cart-drawer')) {
							const lastIdProductAdded = this.querySelector('[name="product-id"]').value;
							localStorage.setItem('lastProductAdded', lastIdProductAdded);
						}

						if (this.emptyCart) {
							upsellCartDrawer();
							this.emptyCart = false;
						}

						/**
						 * Update qty bottom sticky
						 */

						updateQtyMobile();

						/**
						 * Remove loading button collection type list
						 */

						if (this.closest('.product-card-wrapper')) {
							const btnCartListSubmit = this.closest('.product-card-wrapper').querySelector('tpt-list-add-cart');

							if (btnCartListSubmit) {
								btnCartListSubmit.classList.remove('loading');
							}
						}
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				if (this.closest('.product-card-wrapper')) {
					this.errorMessageWrapper = this.closest('.product-card-wrapper').querySelector('.product-form__error-message-wrapper');
				} else {
					this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
				}

				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}

/**
 * Add cart trigger collection type list
 */

if (!customElements.get('tpt-list-add-cart')) {
	customElements.define(
		'tpt-list-add-cart',
		class TptTrigerAddCartList extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.triggerAddCartList.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			triggerAddCartList() {
				const btnCartSubmit = this.closest('.product-card-wrapper').querySelector('product-form [name="add"]');

				if (btnCartSubmit) {
					this.classList.add('loading');
					btnCartSubmit.click();
				}
			}
		}
	);
}
